import api from './api'

// Map label values to API date_range param
// Reports uses '24h','7d','30d','90d' — backend uses 'today','7d','30d','90d'
const mapRange = (range) => {
  const m = { '24h': 'today', '7d': '7d', '30d': '30d', '90d': '90d' }
  return m[range] || range || '7d'
}

const reportsService = {
  getHourlyVolume: (params = {}) =>
    api.get('/api/v1/reports/hourly-volume', {
      params: { ...params, date_range: mapRange(params.date_range) },
    }).then(r => r.data),

  getApprovalBlockTrend: (params = {}) =>
    api.get('/api/v1/reports/approval-block-trend', {
      params: { ...params, date_range: mapRange(params.date_range) },
    }).then(r => r.data),

  getAlertTrend: (params = {}) =>
    api.get('/api/v1/reports/alert-trend', {
      params: { ...params, date_range: mapRange(params.date_range) },
    }).then(r => r.data),

  getSummary: (params = {}) =>
    api.get('/api/v1/reports/summary', {
      params: { ...params, date_range: mapRange(params.date_range) },
    }).then(r => r.data),
}

export default reportsService
